// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ywks","colBig":"styles_colBig__2P_tQ","colSmall":"styles_colSmall__2KDkJ","shopifyNameWrapper":"styles_shopifyNameWrapper__2BmqI"};